{
  "radius": {
    "radius-none": "0px",
    "radius-sm": "4px",
    "radius-md": "8px",
    "radius-lg": "16px",
    "radius-pill": "9999px"
  }
}
